module.exports = __webpack_public_path__ + "static/media/hot-or-cold.96a75f74.png";